import logo from "assets/svg/fullLogo.svg";
import { LogoutIcon, UserCircleIcon } from "assets/icons";
import { getUserDetails, isTokenValid } from "utils/localStorageServices";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useLogout } from "hooks/useLogout";
import NewLogin from "views/Authentication/Login/new-login-flow";
import FirstOnboardingSessionPage from "components/onboardingSession/FirstOnboardingSessionPage";
import ProfilePicture from "components/UI/Avatar/ProfilePicture";
import { getAppUrl } from "utils/subdomainDetection";

// Header Component
export default function Header({
  callbackForLogout,
  setOpenInviteDrawer,
  openInviteDrawer,
  shouldOpenLoginModal,
  setShouldOpenLoginModal,
}: {
  callbackForLogout?: () => void;
  setOpenInviteDrawer?: Dispatch<SetStateAction<boolean>>;
  openInviteDrawer?: boolean;
  shouldOpenLoginModal?: boolean;
  setShouldOpenLoginModal?: Dispatch<SetStateAction<boolean>>;
}) {
  const [fullName, setFullName] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [openLoginModal, setOpenLoginModal] = useState(false);
  const [openOnboardingModal, setOpenOnboardingModal] = useState(false);

  const appOverviewUrl = getAppUrl("/overview");

  // Check if user is logged in
  const userDetails = getUserDetails();
  const hasValidAuth = !!userDetails && isTokenValid();

  // Effect to set user details
  useEffect(() => {
    if (!userDetails) return;

    if (userDetails) {
      userDetails.fullName && setFullName(userDetails.fullName as string);
      setIsLoggedIn(true);
    }
  }, [userDetails]);

  const logout = useLogout(false);
  const logoutFunc = () => {
    setFullName("");
    setIsLoggedIn(false);
    callbackForLogout?.();

    logout();
  };

  useEffect(() => {
    if (shouldOpenLoginModal) {
      setOpenLoginModal(true);
    }
  }, [shouldOpenLoginModal]);

  return (
    <header className="pt-[24.5px]">
      <nav className="flex justify-between items-center h-[40px]">
        <div className="flex items-center gap-2">
          <img src={logo} alt="logo" className="w-[120px]" />
        </div>

        {isLoggedIn ? (
          <div className="bg-[#F2ECE2] border border-[#EFE9DF] flex items-center gap-2 px-2 py-1 rounded-lg hover:bg-[#e0d7ca]">
            <a href={appOverviewUrl} className="flex items-center gap-2">
              <ProfilePicture size={24} enabled={hasValidAuth} />
              {/*  */}
              <p>{fullName}</p>
            </a>
            <button
              onClick={() => {
                logoutFunc();
              }}
            >
              <LogoutIcon />
            </button>
          </div>
        ) : (
          <button
            className="border border-[#EFE9DF] bg-[#F2ECE2] text-lg font-monaMedium text-[#20242A] flex items-center gap-2 px-2 py-1 rounded-lg hover:bg-[#e0d7ca]"
            // onClick={() => navigate("/login")}
            onClick={() => setOpenLoginModal(true)}
          >
            <UserCircleIcon />
            Login
          </button>
        )}
      </nav>

      <NewLogin
        isModal={true}
        open={openLoginModal}
        handleClose={(shouldOpenOnboardingModal = false) => {
          setOpenLoginModal(false);
          setShouldOpenLoginModal?.(false);
        }}
        handleCallbackForLogout={() => {
          if (shouldOpenLoginModal) {
            setOpenInviteDrawer?.(true);
            setShouldOpenLoginModal?.(false);
          }
        }}
      />

      <FirstOnboardingSessionPage
        isModal={true}
        open={openOnboardingModal}
        handleClose={() => {
          setOpenOnboardingModal(false);
          // refetchGetUserProfilePicture();
        }}
      />
    </header>
  );
}
